<template>
	<b-modal
		ref="modal"
		id="confirm-dialog"
		hide-footer
		centered
		body-class="image__container"
		size="xl"
	>
		<img :src="src" alt="Custom Image" class="image" />
	</b-modal>
</template>

<script>
export default {
	name: "ImageViewer",
	data() {
		return {
			src: '',
		};
	},
	methods: {
		show: function (src) {
			this.src = src;
			this.$refs["modal"].show();
		},
		hide: function () {
			this.$refs["modal"].hide();
		},
	},
};
</script>

<style>
.image__container {
	width: 100%;
	height: 100%;
}
.image {
	object-fit: contain;
	width: 100%;
	height: 100%;
}
</style>